import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './components/AdminLogin';
import AdminRoute from './components/AdminRoute';
import Analytics from './pages/Analytics';
import Categories from './pages/Categories';
import Customers from './pages/Customers';
import Dashboard from './pages/Dashboard';
import Discounts from './pages/Discounts';
import Orders from './pages/Orders';
import ProductEditor from './pages/ProductEditor';
import Products from './pages/Products';
import Settings from './pages/Settings';
import './styles/admin.css';

function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="products/new" element={<ProductEditor />} />
        <Route path="products/:productId" element={<ProductEditor />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:orderId" element={<Orders />} />
        <Route path="categories" element={<Categories />} />
        <Route path="customers" element={<Customers />} />
        <Route path="discounts" element={<Discounts />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}

export default AdminApp;
